<template>
  <span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small color="primary" v-bind="attrs" v-on="on" :aria-label="$t('account.usernameSuggestions.open')" @click="open">
          <v-icon small>mdi-auto-fix</v-icon>
        </v-btn>
      </template>
      {{ $t('account.usernameSuggestions.open') }}
    </v-tooltip>
    <v-dialog v-model="dialog" max-width="440" :persistent="checking">
      <v-card>
        <v-card-title class="subtitle-1">{{ $t('account.usernameSuggestions.title') }}</v-card-title>
        <v-card-text>
          <v-progress-linear v-if="loading" indeterminate :aria-label="$t('account.usernameSuggestions.loading')" />
          <v-alert v-if="error" type="error" dense text role="alert">{{ error }}</v-alert>
          <v-radio-group v-if="suggestions.length" v-model="selected" :disabled="loading || checking" hide-details class="mt-0">
            <v-radio v-for="option in suggestions" :key="option.username" :value="option.username" class="mb-3">
              <template v-slot:label>
                <div class="username-option">
                  <span class="font-weight-medium">{{ option.username }}</span>
                  <span class="text-caption grey--text text--darken-1">{{ $t('account.usernameSuggestions.' + option.source) }}</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <p v-else-if="!loading && !error" class="mb-0">{{ $t('account.usernameSuggestions.empty') }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="checking" @click="dialog = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="primary" :loading="checking" :disabled="!selected || loading" @click="choose">{{ $t('account.usernameSuggestions.choose') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';

export default {
  props: { person: { type: Object, required: true } },
  data: () => ({ dialog: false, loading: false, checking: false, error: '', suggestions: [], selected: null }),
  methods: {
    endpoint() { return this.$store.state.endpoint + '/account/usernameSuggestions'; },
    async open() {
      this.dialog = true;
      this.loading = true;
      this.error = '';
      this.suggestions = [];
      this.selected = null;
      try {
        const name = this.person.preferred_name || {};
        const { data } = await axios.post(this.endpoint(), {
          given_name: name.given_name || '', family_name: name.family_name || '',
          emails: (this.person.email || []).map(email => email.trim()).filter(Boolean)
        });
        this.suggestions = data.suggestions;
      } catch (error) {
        this.error = this.$t('account.usernameSuggestions.error');
      } finally { this.loading = false; }
    },
    async choose() {
      if (!this.selected || this.loading || this.checking) return;
      this.checking = true;
      this.error = '';
      try {
        const { data } = await axios.post(this.endpoint(), { username: this.selected });
        if (!data.available) {
          this.suggestions = this.suggestions.filter(option => option.username !== this.selected);
          this.selected = null;
          this.error = this.$t('account.usernameSuggestions.taken');
          return;
        }
        this.$emit('select', this.selected);
        this.dialog = false;
      } catch (error) {
        this.error = this.$t('account.usernameSuggestions.error');
      } finally { this.checking = false; }
    }
  }
};
</script>

<style scoped>
.username-option { display: flex; flex-direction: column; min-width: 0; overflow-wrap: anywhere; }
</style>
